import PushGraph from './PushGraph'

export interface RunnerPartialObject {
  id: string
  type: string
  children: RunnerPartialObject[]
  pushGraph: PushGraph
  dataBinding?: DataBinding
  variableHeight: boolean
  itemId?: number
  listObjId?: string
  attributes: {
    name: string
    x: number
    y: number // this is the original Y taken from the editor, its relative to the screen
    adjustedY: number // this is the Y relative to its parent
    height: number
    width: number
    deviceVisibility: DeviceVisibility | undefined
    masonry?: boolean
    columnCount?: number
    rowMargin?: number
    paddingBottom?: number
  }
  newHeight: number | undefined
  newY: number | undefined
  height: number
  width: number
}

export interface DataBinding {
  options?: DataBindingOptions
}

export interface DataBindingOptions {
  manualPagination?: boolean
}

export interface DeviceVisibility {
  mobile: boolean
  tablet: boolean
  desktop: boolean
}
